module.exports = __webpack_public_path__ + "static/media/Eghtesad_Novin.9f9822ec.svg";